import { render, staticRenderFns } from "./TradiqueLogin.vue?vue&type=template&id=5cbc8bc4&"
import script from "./TradiqueLogin.vue?vue&type=script&lang=js&"
export * from "./TradiqueLogin.vue?vue&type=script&lang=js&"
import style0 from "./TradiqueLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbc8bc4')) {
      api.createRecord('5cbc8bc4', component.options)
    } else {
      api.reload('5cbc8bc4', component.options)
    }
    module.hot.accept("./TradiqueLogin.vue?vue&type=template&id=5cbc8bc4&", function () {
      api.rerender('5cbc8bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/pages/Login/TradiqueLogin.vue"
export default component.exports